/*
  assets/mega-menu.js — desplegable de categorías del item "Shop".

  Sin JS el item sigue siendo un link normal a /collections: el panel arranca
  con el atributo `hidden` NATIVO y solo este script lo revela. Mismo criterio
  que el buscador del header (search.js).

  Abre con hover (con retardo corto al salir, para poder cruzar en diagonal
  hacia el panel sin que se cierre) y con teclado: flecha abajo sobre el
  trigger enfoca el primer link, Escape cierra y devuelve el foco, y se cierra
  al salir el foco del bloque.
*/
(function megaMenu() {
  var root = document.querySelector('[data-mega]');
  if (!root) return;

  var trigger = root.querySelector('[data-mega-trigger]');
  var panel = root.querySelector('[data-mega-panel]');
  if (!trigger || !panel) return;

  var cerrarTimer = null;
  var abierto = false;

  function abrir() {
    if (cerrarTimer) { clearTimeout(cerrarTimer); cerrarTimer = null; }
    if (abierto) return;
    abierto = true;
    panel.hidden = false;
    /* El reflow separa el `hidden = false` del cambio de clase: sin esto el
       navegador aplica los dos en el mismo frame y la transición no corre. */
    void panel.offsetWidth;
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function cerrar(inmediato) {
    if (cerrarTimer) { clearTimeout(cerrarTimer); cerrarTimer = null; }
    if (!abierto) return;
    abierto = false;
    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    if (inmediato) {
      panel.hidden = true;
    } else {
      /* Se espera a que termine el fundido para volver a esconderlo del árbol
         de accesibilidad. */
      setTimeout(function () { if (!abierto) panel.hidden = true; }, 220);
    }
  }

  function cerrarConRetardo() {
    if (cerrarTimer) clearTimeout(cerrarTimer);
    cerrarTimer = setTimeout(function () { cerrar(false); }, 180);
  }

  root.addEventListener('mouseenter', abrir);
  root.addEventListener('mouseleave', cerrarConRetardo);
  root.addEventListener('focusin', abrir);
  root.addEventListener('focusout', function (event) {
    if (!root.contains(event.relatedTarget)) cerrar(false);
  });

  trigger.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      abrir();
      var primero = panel.querySelector('a[href]');
      if (primero) primero.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && abierto) {
      cerrar(true);
      trigger.focus();
    }
  });
})();
